import React, { Component } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button'
import Card from 'react-bootstrap/Card'
import Alert from 'react-bootstrap/Alert'
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../GlobalContext';
import * as MySound from '../MySound';

export class PickItemShorts extends Component {
    static displayName = PickItemShorts.name;
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            alertMessage: "",
            shortsInfo: props.location.state.pickItem,
            pickOptions: props.location.state.pickOptions,
            pickDirection: props.location.state.pickDirection,
            missingQty: props.location.state.pickItem.balance - props.location.state.pickItem.pickedQty,
            damagedQty: 0

        };
        this.history = props.history;
    }
    componentDidMount() {

    }
    goto(page, data) {
        this.history.push({
            pathname: page,
            state: data
        });
    }

    render() {
        return (
            <>
                <h4>Shorts</h4>
                {this.state.alertMessage.length > 0 && <Alert variant="danger">
                    {this.state.alertMessage}
                </Alert>}
                <Form>
                    <Row className="mb-3">
                        <Form.Group as={Col} controlId="formGridEmail">
                            <Form.Label>Pick Number</Form.Label>
                            <Form.Control placeholder="Enter email" readOnly={true} value={this.state.shortsInfo.pickNumber} />
                        </Form.Group>

                        <Form.Group as={Col} controlId="formGridPassword">
                            <Form.Label>Location</Form.Label>
                            <Form.Control readOnly={true} value={this.state.shortsInfo.locationBarcode} />
                        </Form.Group>
                    </Row>
                    <Form.Group className="mb-3" controlId="formGridAddress1">
                        <Form.Label>Product</Form.Label>
                        <Form.Text style={{ fontSize: "14px" }}>{this.state.shortsInfo.code}</Form.Text>
                        <Form.Text>{this.state.shortsInfo.description} </Form.Text>
                        <Form.Text>{this.state.shortsInfo.descriptioN2}</Form.Text>
                    </Form.Group>
                    <Row className="mt-2">
                        <Form.Group as={Col} className="col-2" >
                            <Form.Text style={{ fontSize: "14px" }}>Required</Form.Text>
                        </Form.Group>
                        <Form.Group as={Col} className="col-3">
                            <Form.Text style={{ fontSize: "14px" }}>{this.state.shortsInfo.balance}</Form.Text>
                        </Form.Group>
                        <Form.Group as={Col} >
                            <Form.Text style={{ fontSize: "14px" }}>{this.state.shortsInfo.pickUOM}</Form.Text>
                        </Form.Group>
                    </Row>
                    <Row className="mt-2">
                        <Form.Group as={Col} className="col-2" >
                            <Form.Text style={{ fontSize: "14px" }}>Picked</Form.Text>
                        </Form.Group>
                        <Form.Group as={Col} className="col-3">
                            <Form.Text style={{ fontSize: "14px" }}>{this.state.shortsInfo.pickedQty}</Form.Text>
                        </Form.Group>

                    </Row>
                    <Row className="mt-2">
                        <Form.Group as={Col} className="col-2" >
                            <Form.Text style={{ fontSize: "14px" }}>Missing</Form.Text>
                        </Form.Group>
                        <Form.Group as={Col} className="col-3">
                            <Form.Control 
                                value={this.state.missingQty}
                                onChange={(e) => {
                                    this.setState({ missingQty: e.target.value });
                                }} />
                        </Form.Group>

                    </Row>
                    <Row className="mt-2">
                        <Form.Group as={Col} className="col-2" >
                            <Form.Text style={{ fontSize: "14px" }}>Damaged</Form.Text>
                        </Form.Group>
                        <Form.Group as={Col} className="col-3">
                            <Form.Control
                                value={this.state.damagedQty}
                                onChange={(e) => {
                                    this.setState({ damagedQty: e.target.value });
                                }} />
                        </Form.Group>

                    </Row>

                    <Row className="mt-3">
                        <Form.Group as={Col}>
                            <Button variant="success" size="xs" onClick={() => { this.history.goBack() }}>Cancel</Button>
                        </Form.Group>
                        <Form.Group as={Col}>
                            <Button variant="success" size="xs" disabled={!this.state.shortsInfo.hasAttributes} onClick={() => { this.setState({ viewAttributes: true }) }}>Attributes</Button>
                        </Form.Group>
                        <Form.Group as={Col} >
                            <Button variant="success" size="xs" className="mt-1 float-right" onClick={() => { this.shortItem() }}>Short Pick</Button>
                        </Form.Group>
                    </Row>
                </Form>

            </>
        );
    }

    async shortItem() {
        let userID = MyGlobal.user;
        this.setState({ loading: true });
        const shortRequest = {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ PickData: this.state.shortsInfo, MissingQty: this.state.missingQty, DamagedQty: this.state.damagedQty, userID: userID  })
        };
        fetch('api/PaperlessPicking/ShortItem', shortRequest) //
            .then(async response => {
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ alertMessage: errorText, loading: false });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const result = isJson ? await response.json() : null;
                    if (result.success) {
                        MySound.play(MySound.Sound.next);
                        this.setState({ loading: false, alertMessage: "", });
                        var thisPick = this.state.shortsInfo;
                        this.goto('PickLocation', { pickNumber: thisPick.pickNumber, mheId: thisPick.pick_method_id, rowName: thisPick.row, pickDirection: this.state.pickDirection, pickOptions: this.state.pickOptions });
                    }
                    else {
                        this.setState({ loading: false, alertMessage: result.errorMessage });
                    }
                }
            })
            .catch(error => {
                this.setState({ loading: false, alertMessage: error });
            });
    }


}
export default PickItemShorts;

